import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'
import errorCircle from '../assets/error_circle.png';

const Input = ({ name, value, type, placeholder, validationMessage, disabled, onBlur, onChange }) => {
    return (
        <div className='_kanis_input_group'>
            <div className='_kanis_input_wrapper'>
                <input className='_kanis_input'
                    name={name}
                    value={value}
                    type={type || "text"}
                    placeholder={placeholder || ""}
                    onBlur={() => onBlur()}
                    onChange={onChange}
                    disabled={disabled}
                />
            </div>
            {
                !!validationMessage && (
                    <div className='_kanis_validation_message'>
                        <img src={errorCircle} alt='error' />
                        <div>{validationMessage}</div>
                    </div>
            )}
        </div>
    );
}

export default Input;

Input.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    validationMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

